






































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import ItDisplay from '@/components/itrack/ItDisplay.vue'
import CockpitPerformanceResponse, {Stats} from '@/model/response/CockpitPerformanceResponse'

@Component({
  components: {ItDisplay},
})
export default class PerformanceData extends Vue {
  @Prop({type: Object, required: true}) value!: CockpitPerformanceResponse

  get response() {
    return this.value
  }

  get totalIniciadas() {
    let total = 0

    this.response.row.forEach(((row) => {
      total += row.iniciadas || 0
    }))

    return total
  }

  get totalEmRota() {
    let total = 0

    this.response.row.forEach(((row) => {
      total += row.emRota || 0
    }))

    return total
  }

  get totalAguardandoRota() {
    let total = 0

    this.response.row.forEach(((row) => {
      total += row.aguardandoRota || 0
    }))

    return total
  }

  get total() {
    let total = 0

    this.response.row.forEach(((row) => {
      total += this.totalRow(row)
    }))

    return total
  }

  totalRow(row: Stats) {
    return (row.iniciadas || 0) + (row.emRota || 0) + (row.aguardandoRota || 0)
  }
}
